import { render, staticRenderFns } from "./AttendanceProyek.vue?vue&type=template&id=dda97c3c&scoped=true"
import script from "./AttendanceProyek.vue?vue&type=script&lang=js"
export * from "./AttendanceProyek.vue?vue&type=script&lang=js"
import style0 from "./AttendanceProyek.vue?vue&type=style&index=0&id=dda97c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda97c3c",
  null
  
)

export default component.exports